import React from 'react'

const caseStudies = [
    {
        id: 1,
        subtitle: "Ecommerce and Online Stores",
        title: "Blazingly fast & responsive storefronts",
        img: 'persp4',
        url: 'https://petal-ecommerce.vercel.app/'
    },
    {
        id: 2,
        subtitle: "App Showcases",
        title: "Don't just stand out. Lead the crowd",
        img: 'app-showcase',
        url: 'https://petal-app-showcase.vercel.app/'
    },
    {
        id: 3,
        subtitle: "Business Websites",
        title: "The only limit is your imagination",
        img: 'business-showcase',
        url: 'https://petal-business-showcase.vercel.app/'
    },
]

const Cases = () => {
    return (
        <section className="bg-white cases">
            <div className="container-fluid">
                <div className="row">
                    {caseStudies.map((caseItem) => (
                        <a href={caseItem.url} target="_blank" rel="noopener noreferrer" key={caseItem.id}>
                            <div className="case" key={caseItem.id}>
                                <div className="case-details">
                                    <span>
                                        <span className="inline-block px-2 pt-1 bg-black bg-opacity-80">{caseItem.subtitle}</span>
                                    </span>
                                    <h2 className="px-2 py-1 bg-black bg-opacity-80">{caseItem.title}</h2>
                                </div>
                                <div className="case-image">
                                    <img src={require(`../assets/${caseItem.img}.jpg`)} alt={caseItem.title}/>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Cases
